<div class="h-100">
    @if (showMenubar()) {
        <app-menubar></app-menubar>
    }
    <bcu-spinner></bcu-spinner>
    <horizon-toast></horizon-toast>
    <router-outlet></router-outlet>
</div>

<horizon-app-version-footer backgroundColor="#F6FAFF" strokeColor="#E9EEF2"></horizon-app-version-footer>
